import Component from 'gia/Component';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class Parallax extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    let that = this;

    gsap.fromTo(this.element.querySelector('img'), {
      top:'0vh'
    },{
      top:'20vh',
      scrollTrigger: {
        trigger: that.element,
        scrub: true,
        start: 'top top',
        end: 'bottom top',
      }
    })

  }


}